<div class="modal-header d-flex align-items-center justify-content-between">
    <h4 class="modal-title">Export Planogram</h4>
    <button type="button" class="btn btn-link p-0 border-0" aria-label="Close" (click)="cancel()">
      <i class="bi bi-x-lg"></i>
    </button>
  </div>
  <div class="modal-body p-2">
    <p>Select one of the options below to download the exported Planogram.</p>
    <div class="d-flex p-2 gap-2">
        <button type="button" (click)="confirm(0)" class="btn btn-primary flex-fill">PDF <i class="bi bi-file-earmark-pdf-fill ms-2"></i></button>
        <button type="button" (click)="confirm(1)" class="btn btn-primary flex-fill">Excel <i class="bi bi-file-earmark-excel-fill ms-2"></i></button>
      <button type="button" (click)="confirm(2)" class="btn btn-primary flex-fill">Images <i class="bi bi-file-earmark-excel-fill ms-2"></i></button>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="cancel()">Cancel</button>
  </div>
